import { rateSchema } from "./rate";
import { createZodDto } from "nestjs-zod/dto";

const updateRateSchema = rateSchema
  .pick({ name: true, price: true, credit: true, aiPoints: true, description: true })
  .partial();

export class UpdateRateDto extends createZodDto(updateRateSchema) {}
